export default {
  "": "",
  "24hChange": "24H Change",
  "24hTurnover": "24H Turnover",
  "action": "Action",
  "AddLoan": "Increase",
  "AdjustLoanFail": "Fail to adjust the collateral amount. Please try again later. ",
  "all": "All",
  "apply": "Apply",
  "assets": "Coin",
  "available": "Available",
  "balance": "Available Balance",
  "bi_all": "All",
  "bi_average_change": "24H Average Change",
  "bi_down_amount": "Volume Losers",
  "bi_down_num": "Losers",
  "bi_eth_gas": "ETH Gas",
  "bi_google_tips": "Numbers represent search interest for a term on Google relative to the highest point on the chart for the given region and time. A value of 100 is the peak popularity for the term.",
  "bi_google_trends": "BTC on Google Trends",
  "bi_market_cap": "Global Cryptocurrency Market Cap (USDT)",
  "bi_market_distribution": "Market Cap Distribution",
  "bi_market_sentiment": "Market Sentiment",
  "bi_market_trends": "Cryptocurrency Market Trends",
  "bi_market_volatility": "Cryptocurrency Market Volatility",
  "bi_normal_amount": "Coins With No Change in Volume",
  "bi_normal_num": "With No Change",
  "bi_page_title": "Crypto Market Trend, Sentiment & Volatility Tracker {'|'} Bybit",
  "bi_price_distribution": "Price Change Distribution",
  "bi_ranking": "Rankings",
  "bi_ranking_sector": "Sector",
  "bi_ranking_tips": "Currently only the top 3 by market cap of this sector are displayed.",
  "bi_sentiment1": "Extreme Fear",
  "bi_sentiment2": "Fear",
  "bi_sentiment3": "Neutral",
  "bi_sentiment4": "Greed",
  "bi_sentiment5": "Extreme Greed",
  "bi_social": "Trending on Social Media",
  "bi_td_trade": "Trade",
  "bi_th_action": "Action",
  "bi_th_change": "24H Change",
  "bi_th_currency": "Currency",
  "bi_th_market": "Market Cap",
  "bi_th_price": "Price",
  "bi_th_sector": "Sector",
  "bi_th_up_down": "No. of Gainers/Losers",
  "bi_th_volume": "24H Trading Volume",
  "bi_top_20": "Market Cap",
  "bi_top_gain": "Top Gainer (% Gain)",
  "bi_total_market": "Total Market Cap",
  "bi_trading_distribution": "Trading Volume Distribution",
  "bi_trading_vol": "24H Global Cryptocurrency Trading Volume (USDT)",
  "bi_twitter_explore": "Twitter Explore",
  "bi_twitter_tips1": "Emerging Hot Topics on Twitter",
  "bi_twitter_tips2": "Trending Topics on Twitter",
  "bi_twitter_topics": "Twitter Trending Topics",
  "bi_up_amount": "Volume Gainers",
  "bi_up_num": "Gainers",
  "bi_view": "View",
  "bi_volume_distribution": "Volume Change Distribution",
  "botValidateErrCode101": "The minimum price is too low",
  "botValidateErrCode102": "The minimum price is too high",
  "botValidateErrCode103": "The maximum price is too low",
  "botValidateErrCode104": "The maximum price is too high",
  "botValidateErrCode105": "There are too few grids",
  "botValidateErrCode106": "There are too many grids",
  "botValidateErrCode107": "The investment amount is too low and does not meet the investment requirement",
  "botValidateErrCode108": "The investment amount is too high and exceeds the contract investment limit",
  "botValidateErrCode109": "The take-profit price is too low",
  "botValidateErrCode110": "The take-profit price is too high",
  "botValidateErrCode111": "The stop-loss price is too low",
  "botValidateErrCode112": "The stop-loss price is too high",
  "botValidateErrCode113": "The entry price is too low",
  "botValidateErrCode114": "The entry price is too high",
  "cancel": "No",
  "cancelAll": "Cancel All",
  "cancelOrder": "Cancel",
  "chart": "Chart",
  "close": "Close",
  "confirm": "Yes",
  "contest-about-to-start": "Coming Soon",
  "contest-accumulate-volume": "Cumulative Transaction Volume",
  "contest-accumulate-volume-start": "Registration successful! Your Spot trading vol. will now be counted.",
  "contest-achieve-standards": "Eligible",
  "contest-activity-rules": "Event Rules",
  "contest-activity-rules-title": "Activity Rules",
  "contest-activity-time": "Event Period",
  "contest-countdown": "Till Contest Ends",
  "contest-countdown-day": "DAY(S)",
  "contest-cumulative-volume": "Total Trading Volume ({unit})",
  "contest-current-volume": "Current Transaction Volume",
  "contest-date-range": "{time} {utc} on {month} {date}",
  "contest-dialog-btn-text": "Confirm",
  "contest-difference-to-foward": "{num} {unit} away from the next top trader",
  "contest-earn-rewards": "Rewards Earned ({unit})",
  "contest-ended": "Event Ended",
  "contest-find-more-premium-assets": "Trade more coins on the Spot platform!",
  "contest-latest-update": "Data will be updated at {time}{utc}.",
  "contest-less": "Show Less",
  "contest-limit-desc": "You'll need to meet a minimum Spot trading volume of {amount} {unit} to be eligible for rewards.",
  "contest-list-show-more": "View More",
  "contest-login": "Log In",
  "contest-month": "January,February,March,April,May,June,July,August,September,October,November,December",
  "contest-my-rank": "My Ranking",
  "contest-no-rank": "No ranking available. Stay tuned!",
  "contest-no-rank-yet": "No Ranking Yet",
  "contest-not-registered": "You did not sign up for this trading contest",
  "contest-num-of-participants": "No. of Participants",
  "contest-popup-success": "Trade Now",
  "contest-ranking": "Ranking",
  "contest-register": "Register Now",
  "contest-registered": "Registered",
  "contest-registration-ends": "Registration Ended",
  "contest-rewards-earned": "Rewards Earned ({unit})",
  "contest-share": "Share",
  "contest-symbol-scope": "Spot Pair",
  "contest-terms-conditions": "<b>Terms & Conditions</b>",
  "contest-to-spot-trade": "The event has started. Deposit and trade now!",
  "contest-u-earned-king": "You've won the \"Supreme Traders\" reward",
  "contest-u-earned-sunny": "You've won the \"Top Traders\" reward",
  "contest-unqualified": "Oops, you're not eligible for the event. If you have any questions, please contact customer support.",
  "contest-updated-daily-at": "*Last updated at {time} （UTC0）.",
  "contest-will-start-tips": "Registration successful! The event will start at{time}. Stay tuned!",
  "contest-your-rewards": "Your eligible rewards",
  "contract_account": "Derivatives account",
  "createErrorCode400": "The data sent by the user contains illegal parameters. Please check the error message and error details for more information.",
  "createErrorCode401": "Insufficient balance.",
  "createErrorCode402": "The number of bots created by the user has reached the limit.",
  "createErrorCode403": "FORBIDDEN",
  "createErrorCode404": "The requested resource was not found.",
  "createErrorCode407": "This user type does not support the creation of Grid Bot Subaccounts.",
  "createErrorCode408": "Duplicate regular investment tokens have been selected",
  "createErrorCode409": "Invalid maximum investment amount",
  "createErrorCode410": "Invalid maximum investment amount",
  "createErrorCode411": "The bot has been terminated",
  "createErrorCode412": "The Unified Margin Account is being upgraded",
  "createErrorCode500": "Internal Server Error",
  "createErrorCode501": "Internal Processing Timeout",
  "createErrorCode503": "The DCA Bot cannot be closed at the moment and may be in the process of making a buy transaction",
  "currency": "Coins",
  "dailyRate": "Daily Interest Rate",
  "deposit": "Deposit",
  "detail": "Details",
  "direction": "Direction",
  "end": "End Time",
  "fiat": "Fiat",
  "filled": "Filled",
  "filter": "Filters",
  "from": "Start Time",
  "global_setting_quick_order_desc": "<p>1.Market Order (Quick Order Placement)</p>\n<p>2.Please note that your filled buy quantity may differ slightly from the order quantity you’ve entered.</p>",
  "global_setting_quick_order_label": "Quick Order Placement",
  "global_setting_title": "Customized Settings (Apply to Spot)",
  "hint": "Reminder",
  "innovateQuota": "Available Quota",
  "kline": "Chart",
  "l_version_tip": "Please update your Bybit app to the latest version to join the Bybit Launchpad event.",
  "LastTradedPrice": "Price",
  "leverage": "Leverage",
  "leverage_can_borrow": "Borrowable",
  "leverage_can_deposit": "Margin",
  "leverage_data": "Margin Data",
  "leverage_forced_order": "Liquidation order",
  "leverage_go_trade": "Trade Now",
  "leverage_loan_limit": "Max. Amount to Borrow",
  "leverage_min_borrow": "Min. Borrow Amount",
  "leverage_off_trade_tip": "Please turn on leverage and then trade with leverage.",
  "leverage_yearly_rate": "Yearly Interest Rate",
  "leverageCloseErrInfo": "Failed! Please complete all repayments before turning off Margin Trading.",
  "leverageCloseTips": "Failed to disable Margin Trading, as there are active Spot Margin orders in your account.",
  "leverageLoanTips": "This action could not be completed as your Unified Margin Account's IM/MM utilization rate has exceeded the threshold.",
  "leverageLP_banner_title": "Bybit Spot Margin Trading",
  "leverageLP-banner-desc": "Invest with borrowed funds to boost returns",
  "leverageLP-faq-a1": "For a complete list, please refer to the <a href=\"{url}\" target=\"_blank\" > list of collateralized assets and borrowable assets (Margin trading).</a>",
  "leverageLP-faq-a10": "Please click on Orders –> Spot Order –> Repayment History –> Liquidations to view your liquidation records.",
  "leverageLP-faq-a11": "Please click on Orders → Spot Orders → Repayment History to view your borrowing and repayment history.",
  "leverageLP-faq-a2": "Margin trading on Bybit incurs Spot trading fees, interest, and position closing fees. Please refer to <a href=\"{url}\" target=\"_blank\" >Bybit Margin Spot Trading: Commissions & Overview for the fee breakdown.</a>",
  "leverageLP-faq-a3": "Margin trading will require you to collateralize crypto assets to borrow leverage on Bybit's Spot account.",
  "leverageLP-faq-a4": "No. You are no longer eligible for leveraged trading if you have active Institutional Lending. Should you require your UID to be removed from the Institutional Lending user list, please email institutional_services{'@'}bybit.com to proceed with Bybit Margin Trading.",
  "leverageLP-faq-a5": "Lending rates vary based on your VIP level. Please check the <a href=\"{url}\" target=\"_blank\"> leverage data for more details.</a>",
  "leverageLP-faq-a6": "Interest is calculated on an hourly basis. Please note that time increments of less than one hour will also be calculated on an hourly basis.",
  "leverageLP-faq-a7": "You will receive two (2) risk notifications via SMS and email:\n\n(1) When the risk level of your Spot account is ≥ 87%, a risk alert will be triggered. You'll receive an SMS and email notification as a reminder to add collateral (transfer more collateral assets) to prevent the forced closing of your position.\n\n(2) When the risk level of your Spot account is ≥ 95%, you'll receive a mandatory forced liquidation alert via SMS and email to inform you that your position has been liquidated.\n\nPlease refer to <a href=\"{url}\" target=\"_blank\"> Risk and Forced Liquidation (Spot Leveraged Trading) for more details about the process and criteria.</a>",
  "leverageLP-faq-a8": "The Margin Insurance Fund (MAF) covers the loss of a trader's position after the forced liquidation of a position is carried out, due to insufficient funds in the account, in order to repay the loan.\n\nIf your Spot account becomes insolvent, the platform will use the MAF to cover your debt. Therefore, a liquidation fee will be levied to cover the cost of the MAF.",
  "leverageLP-faq-a9": "If there are still any outstanding funds borrowed after the margin has been used to repay the loan, the remaining loss will be insured by the Margin Insurance Fund.",
  "leverageLP-faq-q1": "Which cryptocurrencies can be used as collateral or borrowable assets in margin trading?",
  "leverageLP-faq-q10": "Where can I view the history of the liquidation charged?",
  "leverageLP-faq-q11": "Where can I access my borrowing and repayment history?",
  "leverageLP-faq-q2": "Are there any commission fees incurred for Bybit Margin trading?",
  "leverageLP-faq-q3": "Which Bybit account should I be using when trading on margin?",
  "leverageLP-faq-q4": "Can I trade with margin or leverage if I have Institutional Lending activated?",
  "leverageLP-faq-q5": "What are the lending rates for Bybit Margin Trading?",
  "leverageLP-faq-q6": "How long does it take for interest to begin to accrue?",
  "leverageLP-faq-q7": "Under which circumstances will I receive a risk notification for Margin Trading?",
  "leverageLP-faq-q8": "What is the Margin Insurance Fund?",
  "leverageLP-faq-q9": "What happens if I have insufficient funds in my Spot account in the event of a forced liquidation?",
  "leverageLP-faq-title": "FAQ",
  "leverageLP-feature-title": "Why Choose Margin Trading?",
  "leverageLP-feature1": "Magnifying Trading Revenue",
  "leverageLP-feature2": "Support of Long/Short Position Trading",
  "leverageLP-feature3": "Improved Capital Utilization",
  "leverageLP-feature4": "Diversification of Assets",
  "leverageLP-whats-leverage": "What Is Spot Margin Trading?",
  "leverageLP-whats-leverage-c": "Bybit's Spot Margin trade is a derivative product of Spot trading allowing traders to borrow and leverage funds by collateralizing their crypto assets. The borrowed funds will be used to amplify trade profits on a successfully leveraged position in low-or high-volatility markets.",
  "leverageTest": "Margin Trading Quiz",
  "leverageTestSubTitle": "You must answer all questions correctly to get started with Margin Trading.",
  "leverageTryAgain": "System error. Please try again later.",
  "liquidate": "Liquidated",
  "liquidationErrorInfo": "Failed! Liquidation has been triggered on your account.",
  "load_more": "Load More",
  "loan": "Borrow",
  "loan_limit": "Loan Term",
  "loan_spot_account": "Spot account",
  "loanLualityDeposit1": "You can only reduce your collateral amount when the current LTV ratio is lower than the Initial LTV. ",
  "loanLualityDeposit2": "The maximum reduction in collateral is the amount needed to bring the LTV ratio back to its initial level.",
  "loanLualityDeposit3": "The collateral amount cannot be reduced if the value of reduced amount is lower than that of the adjustable margin.",
  "loanTime": "Timestamp",
  "login": "Log In",
  "lp_go_home": "Back",
  "lpn_one_progress_info": "The result is expected to be available in",
  "lpn_order_btn": "My Subscription",
  "lpn_order_btn_cancel": "Cancel",
  "lpn_order_btn_confirm": "Confirm",
  "lpn_order_submit_error": "Failed!",
  "lpn_order_submit_error_desc": "System error. Please try again later.",
  "lpn_unfold": "More",
  "lt_all": "All",
  "lt_amount": "Amount",
  "lt_amount_not_enough": "Insufficient {currency} available balance!",
  "lt_entry_tips": "Leveraged Tokens Trading is supported for {symbol} ({direction}). Trade now!",
  "lt_freerate": "Fee Rate",
  "lt_lowcase_redemption": "redemption",
  "lt_lowcase_subscription": "subscription",
  "lt_open_success_txt": "Congrats, you've successfully enabled Leveraged Tokens!",
  "lt_orders_submitted": "Your {ordertype} order of {quantity} has been successfully submitted.",
  "lt_redemption": "Redemption",
  "lt_redemption_failed_change_position": "Rebalancing has been triggered for the selected pair, and redemption is currently not supported. Please try again later.",
  "lt_redemption_failed_closed": "Redemption is currently not supported for the selected asset. Please try again later.",
  "lt_redemption_failed_input_quantity": "Please enter redemption amount",
  "lt_redemption_failed_net_worth": "The net asset value is invalid, and redemption is currently not supported. Please try again later.",
  "lt_redemption_failed_wear_position": "Your account is being liquidated, and redemption is currently not supported. Please try again later.",
  "lt_redemption_max_quanlity": "The max. redemption quantity per transaction for the selected asset cannot be higher than {quantity}.",
  "lt_redemption_min_quanlity": "The min. redemption quantity per transaction for the selected asset cannot be less than {quantity}.",
  "lt_redemption_tips": "The actual redemption amount may vary slightly.",
  "lt_subscription": "Subscription",
  "lt_subscription_failed_change_position": "Rebalancing has been triggered for the selected pair, and subscription is currently not supported. Please try again later.",
  "lt_subscription_failed_close_position": "Your account is being liquidated, and subscription is currently not supported. Please try again later.",
  "lt_subscription_failed_closed": "Subscription is currently not supported for the selected asset. Please try again later.",
  "lt_subscription_failed_input_amount": "Please enter subscription amount",
  "lt_subscription_failed_invalid_value": "The net asset value is invalid, and subscription is currently not supported. Please try again later.",
  "lt_subscription_failed_large_amount": "Your subscription amount is too large, and your risk level will increase. There may be liquidation risks.",
  "lt_subscription_failed_wear_position": "Your account is in negative equity, and subscription is currently not supported. Please try again later.",
  "lt_subscription_max_amount": "The max. subscription amount per transaction for the selected asset cannot be higher than {amount}.",
  "lt_subscription_min_amount": "The min. subscription amount per transaction for the selected asset cannot be less than {amount}.",
  "lt_subscription_redemption": "Subscription & Redemption",
  "lt_subscription_redemption_records": "Subscription & Redemption History",
  "lt_subscription_tips": "The actual subscription amount may vary slightly.",
  "lt_subscription_usdt_not_enough": "Insufficient USDT available balance! Please make a deposit or transfer first.",
  "lt-landing-banner-desc": "Leverage Without the Risk of Liquidation",
  "lt-landing-banner-title": "Bybit Leveraged Tokens",
  "lt-landing-faq-a1": "NAV, or net asset value, refers to the value of a Leveraged Token. The NAV of a Leveraged Token moves in line with the price fluctuations in the Perpetual Contracts market.",
  "lt-landing-faq-a2": "Using BTC as an example, \n\nBTC3L refers to a Leveraged Token holding long positions of BTCUSDT Perpetual Contracts with 3x leverage.\n\nBTC3S indicates a Leveraged Token holding short positions of BTCUSDT Perpetual Contracts with 3x leverage.",
  "lt-landing-faq-a3": "Leveraged Token trading will be channeled directly through your Bybit Spot Account.",
  "lt-landing-faq-a4": "Please refer to <a href=\"{url}\" target=\"_blank\" >Differences Between Leveraged Tokens and Derivatives Trading</a>.",
  "lt-landing-faq-a5": "Please refer to <a href=\"{url}\" target=\"_blank\" >Bybit Leveraged Tokens: Fees Explained </a>.",
  "lt-landing-faq-a6": "There are no liquidation risks. \n\nTaking BTC3L as an example, the target leverage range is [2,4]. The rebalancing mechanism will automatically be triggered when the actual leverage ratio is ≥ 4x or ≤ 2x, to be adjusted to achieve the target leverage of 3x.\n\nNote: Please be aware that the net asset value of a Leveraged Token could fall to zero, in which case it would be unrecoverable.",
  "lt-landing-faq-a7": "Rebalancing is a process to make sure that the Perpetual Contracts positions of the underlying asset will be dynamically adjusted to achieve the target leverage. The rebalancing mechanism will be automatically triggered when the actual leverage ratio falls outside the target leverage range. \n\nFor more information, please refer to <a href=\"{url}\" target=\"_blank\"> Bybit Leveraged Tokens Rebalancing Mechanism</a>.",
  "lt-landing-faq-a8": "Currently, withdrawals are not supported.",
  "lt-landing-faq-q1": "What is net asset value (NAV)?",
  "lt-landing-faq-q2": "What does the symbol for Leverage Tokens represent?",
  "lt-landing-faq-q3": "Which account can I use to trade Leveraged Tokens on Bybit?",
  "lt-landing-faq-q4": "What’s the difference between Leveraged Tokens and Derivatives trading on Bybit?",
  "lt-landing-faq-q5": "What are the fees associated with a Leveraged Token?",
  "lt-landing-faq-q6": "Under what circumstances will my Leveraged Token positions be liquidated?",
  "lt-landing-faq-q7": "What is the rebalancing mechanism?",
  "lt-landing-faq-q8": "Can Leveraged Tokens be withdrawn?",
  "lt-landing-faq-title": "FAQ",
  "lt-landing-feature-title": "Advantages of Leveraged Tokens",
  "lt-landing-feature1": "Leveraged exposure that may amplify profitability",
  "lt-landing-feature2": "No liquidation risks",
  "lt-landing-feature3": "High capital utilization",
  "lt-landing-feature4": "Trade with ease",
  "lt-landing-learn-more": "Learn More",
  "lt-landing-operation": "Action",
  "lt-landing-symbol": "Trading Pair",
  "lt-landing-whats-lt": "What is a Leveraged Token?",
  "lt-landing-whats-lt-c": "A Leveraged Token is a derivatives product providing leveraged exposure to the underlying asset with no margin requirements, which may amplify profitability and has no liquidation risks. \n\nEach Leveraged Token represents a basket of Perpetual Contract positions. \n\nThe net asset value (NAV) of a Leveraged Token moves in line with the price fluctuations in the Perpetual Contracts market.",
  "lt-learning-video-title": "Video teaching for beginners of leveraged tokens",
  "ltLearningVideo": "Video tutorial",
  "ltNav": "Net Asset Value",
  "ltOpenRiskContent": "Leveraged Tokens provide you with leveraged exposure to the underlying asset.\n\nBybit reserves the right to modify the Terms of Service and make any of the following moves based on market conditions without notifying users in advance:\n\n1. Delist any Leveraged Tokens.\n\n2. Add or adjust restrictions, such as position quantity limit. Please visit our Blog for the details if such a change is announced.\nIn the case of the position quantity limit, the actual quantity you'll be able to access can vary from the officially stated quantity due to technical issues. Please be aware of the risks associated with it. \n\n3. Adjust the positions of the underlying asset dynamically to achieve the target leverage. \n\n4. Remove any term in the Terms of Service.\n\nPlease ensure that you fully understand Leveraged Tokens as a financial product, and invest rationally based on your risk tolerance and level of expertise. Bybit shall not be responsible for any losses and risks associated with trading Leveraged Tokens. \n\nBy proceeding, you also agree to the <a href={url} target=\"\"_blank\"\">Terms of Service</a> of trading Leveraged Tokens.",
  "ltOpenRiskSubmit": "Acknowledge & Enable Leveraged Tokens",
  "ltOpenRiskTitle": "Leveraged Tokens Service Agreement",
  "ltTestDialogContent": "Are you sure that you want to exit the quiz? Your answers will not be saved.",
  "ltTestDialogContinue": "No",
  "ltTestDialogExit": "Yes",
  "ltTestDialogTitle": "Confirmation",
  "ltTestDone": "You've answered <span>{num}/{numAll}</span> questions",
  "ltTestDoneFail": "Oops, you've only answered {num}/{numAll} question(s) correctly! Please take the quiz again.",
  "ltTestPassContent": "Congrats, you've passed the quiz!",
  "ltTestPassRead": "Read More",
  "ltTestPassReject": "Skip Now",
  "ltTestResubmit": "Please Try Again",
  "ltTestSubmit": "Submit Now",
  "ltTestSubTitle": "You must answer all questions correctly to start trading Leveraged Tokens.",
  "ltTestTitle": "Quiz",
  "ltUnderlying": "Underlying",
  "margin_coin": "Coin",
  "margin_discount": "Multiplier",
  "margin_discount_eg": "Example:",
  "margin_discount_eg_body": "Suppose Trader A has 1 BTC, 1000 BIT and 100 TRX in his Spot Account. \nAssuming the market price of BTC, BIT and TRX to be 50,000 USDT, 5 USDT and 0.50 USDT respectively, the total collateral value for Margin Trading would be: \n(1 (Quantity) * 50000 (Price) * 1 (Multiplier) * 1 ) + (1,000 (Quantity) * 5 (Price) * 0.9 (Multiplier) + (100 (Quantity) * 0.5 (Price) * 0 (Multiplier) = 54,500 USDT.",
  "margin_discount_rate": "Margin Specifications",
  "margin_lq_order": "Liquidation order",
  "MARKET": "Market Price",
  "max": "Maximum",
  "more": "More",
  "network_error": "Request failed. Please try again later.",
  "NEW": "Active",
  "nextPage": "Next Page",
  "nodata": "No Records Found",
  "none": "None",
  "noRecordFound": "No Records Found",
  "og_description": "Buy, sell, and trade {symbol} securely with Bybit's spot exchange. Trade with confidence and enjoy trading at a low fee and deep liquidity.",
  "og_title": "{symbol} {'|'} Buy, Sell & Trade at Lower Fees {'|'} Bybit Spot",
  "ol_agree": "I have read and agree to",
  "ol_agrmt": "Digital Asset Loan Agreement",
  "ol_agrmt_2": "<Digital Asset Loan Agreement>",
  "ol_agrmt_err": "The Digital Asset Loan Agreement must be signed.",
  "ol_amt": "Loan Amount",
  "ol_amt_err": "The {condition} loan amount is {amount} {unit}",
  "ol_amt_tip": "Please enter your loan amount",
  "ol_app_sub": "Loan Application Submitted",
  "ol_app_time": "Time of Application",
  "ol_apply_title": "Online Application for Institutional Lending",
  "ol_cancel": "Are you sure you want to exit this application?",
  "ol_cfm_product": "Institutional Lending Products",
  "ol_check_app": "Check your application",
  "ol_coin": "Coin",
  "ol_col_amt": "Amount",
  "ol_col_app_tm": "Time of Application",
  "ol_col_dl": "Term of Loan",
  "ol_col_no": "Order Number",
  "ol_col_pn": "Name of Product",
  "ol_col_sub": "Subaccounts",
  "ol_confirm": "Loan Application Confirmation",
  "ol_contact_desc": "Please make sure all information is up to date and valid, as all risk alerts will be sent to your email address and mobile phone.",
  "ol_contact_tip": "Please contact our Business Development team",
  "ol_contact_title": "Contact Details",
  "ol_detail_title": "Loan Application Details",
  "ol_eg": "Example",
  "ol_email": "Email Address",
  "ol_email_err_invalid": "Invalid email address",
  "ol_email_tip": "Please enter your email address",
  "ol_max": "maximum",
  "ol_mgr": "Your BD Manager‘s ID",
  "ol_mgr_err_invalid": "Invalid ID",
  "ol_mgr_link": "Click to get your BD Manager's ID",
  "ol_mgr_tip": "Please enter your BD Manager's ID",
  "ol_min": "minimum",
  "ol_mine_title": "My Loan Applications",
  "ol_month": "{month} Months",
  "ol_no_code_rcd": "No country code found",
  "ol_notice_desc": "<li>Institutional Lending is available for institutional traders only.</li>\n<li>Institutional traders applying for loans should possess assets of at least 500,000 USDT.</li>\n<li>The loans can be used in the Spot or Derivatives market depending on the product selected.</li>",
  "ol_notice_desc_lmt": "<li>The minimum loan amount is 1,000,000 USDT and the maximum is 20,000,000 USDT.</li>",
  "ol_notice_title": "Institutional Lending Instructions",
  "ol_phone": "Mobile Number",
  "ol_phone_err": "Please select your area code and enter your mobile number",
  "ol_phone_err_invalid": "Invalid mobile number",
  "ol_phone_tip": "Please enter your mobile number",
  "ol_prd": "Please select an Institutional Lending product",
  "ol_prd_3x_spot": "Institutional Lending: 3x Leverage (Spot)",
  "ol_prd_3x_spot_futures": "Institutional Lending: 3x Leverage (Spot and Derivatives)",
  "ol_prd_5x_spot": "Institutional Lending: 5x Leverage (Spot)",
  "ol_prd_link": "Learn more about the product",
  "ol_prd_tip": "If you convert assets in your Spot Account to non-margin assets, the risk of liquidation will increase. For details of the supported margin assets on Bybit's Spot market, please click <a href={url} target=\"_blank\">here</a>.",
  "ol_recent_year_only": "Search results include loan applications of the most recent year only.",
  "ol_status": "Application Status",
  "ol_status_list": "All,Reviewed,Application Received,Rejected,Disbursed",
  "ol_subacc": "Add Subaccount(s)",
  "ol_subacc_tip": "Please enter the UID of Subaccount(s) you wish to add. If you need to add multiple Subaccounts, please contact our Business Development team.",
  "ol_term": "Term of Loan",
  "ol_term_err": "Please select the term of your loan application.",
  "ol_unit_month": "Unit: Month",
  "ol_view_agrmt": "View Agreement Attachments",
  "operationSuccess": "Success",
  "or": "or",
  "orderBook": "Order Book",
  "orderHistory": "Order History",
  "orderId": "Order ID",
  "orderSuccessful": "Order(s) submitted successfully!",
  "orderType": "Order Type",
  "otcErrorInfo": "Oops, you've already enabled Institutional Lending, and are no longer eligible for Margin Trading.",
  "outstanding": "Outstanding",
  "pa_accumated_profit_descript": "Cumulative Profits is the sum of profits generated each day over a given period. The graph only shows data as of the prior day.",
  "pa_accumated_profit_select": "Actual Cumulative Profit",
  "pa_accumated_profit_title": "Cumulative Profits",
  "pa_accumulated_account": "Cumulative ROI of the Spot Account",
  "pa_accumulated_btc": "Cumulative price change of BTC (%)",
  "pa_accumulated_btc_select": "Actual Cumulative price change of BTC (%)",
  "pa_accumulated_pnl": "7 Day's PnL",
  "pa_accumulated_pnl_select": "Actual Cumulative ROI",
  "pa_accumulated_roi_descript": "Cumulative ROI evaluates the efficiency of profits generated in an investment over a given period. The graph only shows data as of the prior day.",
  "pa_accumulated_roi_title": "Cumulative ROI",
  "pa_assets_distribution_descript": "Assets Distribution is the weightage of each asset in the Spot Account relative to the total value of all assets in USDT.",
  "pa_assets_distribution_title": "Assets Distribution",
  "pa_daily_pnl": "Today's P&L",
  "pa_daily_profit_descript": "The daily P&L graph only shows data as of the prior day.",
  "pa_daily_profit_select": "P&L for the day",
  "pa_daily_profit_title": "Daily P&L",
  "pa_last_30_day": "Last 30 Days",
  "pa_last_7_day": "Last 7 Days",
  "pa_last_90_day": "Last 90 Days",
  "pa_others": "Others",
  "pa_page_description": "Stay up-to-date on the performance of your Spot portfolio and adapt your investment strategy to real-time market changes.",
  "pa_page_title": "P&L Analysis of Spot Assets",
  "pa_quantity": "{Coin} Quantity",
  "pa_spot_pnl_descript": "1. The Spot P&L data will be updated at 12AM UTC (midnight) each day.\n2. The latest Spot P&L data will be calculated between 12AM UTC (midnight) and 6AM UTC and will be displayed after 6AM (UTC) each day.",
  "pa_spot_pnl_title": "Spot P&L Analysis",
  "pa_total_assets": "Total Assets",
  "pa_total_assets_value_descript": "Total Asset Value refers to the total value of all assets in the Spot Account (including borrowed assets), and will be affected by withdrawals, transfers (in and out), loans and margin positions.",
  "pa_total_assets_value_select": "Asset Value",
  "pa_total_assets_value_title": "Total Assets Value",
  "pa_update_on": "Last Updated:",
  "pa_value": "{Coin} Value",
  "pa_weightage": "{Coin} Weightage",
  "pauseTradeTip": "{symbol} is currently not available for trades. For more information, please refer to our<a href={url} target=\"_blank\">blog</a>.",
  "placeHolder": "Select",
  "prevPage": "Previous Page",
  "price": "Price",
  "quantity": "Qty",
  "ReduceLoan": "Decrease",
  "ReduceLoanAssets": "Reduce Collateral Amount",
  "ReduceLoanTip1": "The collateral amount cannot be reduced unless the current LTV ratio is lower than the Initial LTV.  ",
  "ReduceLoanTip2": "The collateral amount cannot be reduced unless the value of the reduced amount is lower than that of the adjustable margin.",
  "ReduceLoanTip3": "The collateral amount cannot be reduced if the current LTV ratio meets or exceeds the initial LTV ratio. Please try again. ",
  "ReduceLoanTip4": "You can manage the collateral amount on the Order page. You can increase your collateral at any time and decrease it only when the current LTV ratio is lower than the Initial LTV. ",
  "repayment": "Repay",
  "reset": "Reset",
  "reverse_contract_account": "Inverse Derivatives account",
  "riskWarning": "Confirmation",
  "search": "Search",
  "side": "Direction",
  "signup": "Sign Up",
  "spot_account": "Spot Account",
  "status": "Status",
  "stop_limit": "TP/SL",
  "stop_limit_tips_2": "Margin Trading cannot be activated if you have a Take-Profit or Stop-Loss order in place.",
  "success": "Success",
  "sure": "sure",
  "tests1": "",
  "times": "times",
  "timestamp": "Timestamp",
  "title_404": "404 {'|'} Bybit Spot Trading",
  "to": "To",
  "toastTheSymbolNotExist": "Oops, the Spot pair you've selected is currently not available for trades.",
  "total": "Total",
  "tradeChange": "Change %",
  "tradeId": "Transaction ID",
  "transfer": "Transfer",
  "usdc_contract_account": "USDC Derivatives account",
  "VIP99": "Supreme VIP",
  "volume": "Filled Qty",
  "vote_btn_trade": "Trade"
}